import { creepyStage } from "@/lib/creepyStage";

/**
 * Halloween season — October 1 until November 1 at 06:00 Copenhagen time,
 * every year. Shares the exact window of the site-wide creepy theme and the
 * Halloween Night wheel deadline, so the menu logo, tagline and spooks stay
 * on for the whole night.
 */
export { halloweenSeasonYear as getHalloweenYear } from "@/lib/yearlySpinBadge";

export function isHalloweenPeriod(now = new Date()): boolean {
  return creepyStage(now) > 0;
}

export const halloweenColors = {
  orange: "25 95% 53%",
  purple: "270 70% 45%",
  pumpkin: "24 90% 50%",
  slime: "90 70% 42%",
};

export const halloweenRecipeThemes = [
  { value: "pumpkin-feast", label: "Pumpkin Feast", emoji: "🎃" },
  { value: "witches-brew", label: "Witch's Brew", emoji: "🧪" },
  { value: "haunted-dinner", label: "Haunted Dinner", emoji: "👻" },
  { value: "monster-mash", label: "Monster Mash", emoji: "🧟" },
  { value: "candy-cauldron", label: "Candy Cauldron", emoji: "🍬" },
  { value: "spooky-snacks", label: "Spooky Snacks", emoji: "🦇" },
];
